module.exports = __webpack_public_path__ + "img/logo_main_hp.5e81559e.svg";